/* eslint import/prefer-default-export: 0 */
import _ from 'lodash';
import matchSorter, { rankings } from 'match-sorter';

export const searchObjects = (objects, searchFilter, keys, numberKeys = ['id']) => {
  const searchFilterIsNumber = searchFilter && _.isSafeInteger(searchFilter * 1);
  let filteredByNumber = [];

  if (searchFilterIsNumber) {
    filteredByNumber = matchSorter(objects, searchFilter, {
      keys: numberKeys,
      threshold: rankings.EQUAL,
    });
  }

  return !_.isEmpty(filteredByNumber)
    ? filteredByNumber
    : matchSorter(objects, searchFilter, {
        keys,
        threshold: rankings.CONTAINS,
      });
};
